import { render } from "./corpCoupon-edit.vue?vue&type=template&id=19929066&scoped=true"
import script from "./corpCoupon-edit.vue?vue&type=script&lang=js"
export * from "./corpCoupon-edit.vue?vue&type=script&lang=js"

import "./corpCoupon-edit.vue?vue&type=style&index=0&id=19929066&lang=less&scoped=true"

import exportComponent from "E:\\Projects\\YCTECH\\ycform\\trunk\\ycform-admin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-19929066"]])

export default __exports__